import React from "react";
import "./Intro.css"
import Background from "./Background";

class Intro extends React.Component {
    render() {
        return (
            <div className={"intro"} id={"home"}>
                <section>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                    <Background/>
                </section>
                <div className={"nav"}>
                    <a href={"#"}>Home</a>
                    <a href={"#aboutMe"}>About</a>
                    <a href={"#skills"}>Skills</a>
                    <a href={"#experience"}>Experience</a>
                    <a href={"#project"}>Projects</a>
                    <a href={"#contact"}>Contact</a>
                </div>
                <div className={"message"}>
                    <div>
                        <h1 className={"message-wave"}> 👋🏼</h1>
                        <h1 className={"message-intro"}>Hello, I am</h1>
                        <h1 className={"message-name"}>Mrigank Anand</h1>
                    </div>
                </div>
                <div className={"title"}>
                    <h1 className={"message-job "}>Software Developer | Student | CSE, NITH
                    </h1>
                </div>
                <div className={"social-links"}>
                    <div>
                        <a href={"https://github.com/spiderxm"} target={"_blank"}>
                            <i className="fab icon fa-github"></i>
                        </a>
                    </div>
                    <div>
                        <a href={"https://www.linkedin.com/in/mrigankanand/"} target={"_blank"}>
                            <i className="fab icon fa-linkedin"></i>
                        </a>
                    </div>
                    <div>
                        <a href={"https://www.facebook.com/mrigank.anand.9/"} target={"_blank"}>
                            <i className="fab icon fa-facebook"></i>
                        </a>
                    </div>
                    <div>
                        <a href={"https://www.instagram.com/mrigank_anand/"} target={"_blank"}>
                            <i className="fab icon fa-instagram"></i>
                        </a>
                    </div>
                    <div>
                        <a href={"https://www.instagram.com/mrigank_anand/"} target={"_blank"}>
                            <i className="fab icon fa-qwiklabs"></i>
                        </a>
                    </div>
                </div>
                <div className={"profile-image"}>
                    <img src={"https://avatars.githubusercontent.com/u/53966291?v=4"}/>
                </div>
            </div>
        );
    }
}

export default Intro;